import { useNavigate } from "react-router-dom";
import { PlayerCardData, PlayerClubCountryInfoData, PlayerClubInfoData } from "../../styled-components/PlayerCard.Styles";
import { IClubSearchResponse } from "../../types/IClubSearch";
import noImageClub from "../../assets/icons/noImageClub.svg";
import LabelText from "../../ui/LabelText";
import SecondaryButton from "../../ui/SecondaryButton";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import styled from "styled-components";
import LabelNumber from "../../styled-components/LabelNumber";
import noImageFlag from "../../assets/icons/noImageFlag.svg";
import { formatNumberToKAndM, formatNumberToKAndMwithoutsign } from "../../utils/formatNumberToKandM";
import YellowCardSvg from "../../assets/event_icons/Yellow_card.png";
import RedCardSvg from "../../assets/event_icons/red_card.png";
import { ReactNode, useEffect, useState } from "react";
import { addUpdateClubSortListData } from "../ClubComparison/addOrUpdateClubSortlist";
import { useAuth } from "../../contexts/AuthContext";
import { useLoading } from "../../contexts/LoadingContext";
import EmptyDataButton from "../../ui/EmptyDataButton";
import Pitch from "../Pitch";
import HeaderTextWithIcon from "../PlayerDetail/HeaderTextWithIcon";
import { BothPlayerImageContainer, FullViewBtn, PartnershipScoreContainer, PlayerImageContainer } from "../PlayerInfo";
import { ModuleSpinner } from "../../ui/LoadingSpinner/ModuleSpinner";
import VisibleON from "../../assets/icons/VisibleON.png";
import { FullModuleFitView } from "../../pages/Chemistry/UIContent";
import { useTheme } from "../../contexts/ThemeContext";
import ModuleFitLargePitch from "../ModuleFitLargePitch";
import Switch from "../../ui/CustomSwitch";
import IApiResponse from "../../types/IApiResponse";
import { ChemistryData, fetchFormationData } from "../../pages/Chemistry/Utils";
import { postData } from "../../services/api";
import apiUrls from "../../config/apiUrls";
import handleApiResponse from "../../utils/handleApiResponse";
import { ChemistryPlayerPositions, FormationData, TeamChemistry } from "../../types/IOption";
import SummaryBar from "../SummaryBar";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import PWNotification from "../PWNotification";
import CustomizedTooltips from "../../ui/Tooltip";
import { getLeaguePositionDetails } from "../../utils/clubFormationsFunctions";
import InfoIcon from '../../assets/icons/infoicon.svg'




interface IClubDetails {
    clubData: IClubSearchResponse;
    isOpen: boolean;
    onToggle: (event: React.MouseEvent) => void;
    //playerData?: { playerId: number; playerClubURL: string };
    type?: string;
}

const ModuleChemHeader = styled.p`
  color: ${({ theme }) => theme.playerColor};
`;

const StyledTags = styled.div`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.tabBorderColor};
  width: 100%;
  height: 100%;
  .icon {
    color: ${({ theme }) => theme.NumberColor};
  }
`;

const StyledIcon = styled.div`
  margin-left: 15px;
  padding-left: 15px;
  border-left: 2px solid ${({ theme }) => theme.playerDataBorder};
  height: 40px;
  align-content: center;
`;

const TableRow = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
`;

const ClubDetails: React.FC<IClubDetails> = ({ clubData, isOpen, onToggle, type }) => {

    const { theme } = useTheme();
    const navigate = useNavigate();
    const { userData } = useAuth();
    const { loading ,startLoading, stopLoading } = useLoading();
    const [toggleAddSimilarButton, setIsToggleAddSimilarButton] = useState<boolean>();
    const [addedClubShortList, setAddedClubShortList] = useState<boolean>(false);
    const [displayCustomNotification, setDisplayCustomNotification] = useState<boolean>(false);
    const [customNotificationContent, setCustomNotificationContent] = useState<ReactNode>(null);
    const profitLossStyled = clubData?.totalProfitLoss !== 0 && clubData?.totalProfitLoss !== null ? {
        background: clubData?.totalProfitLoss > 0 ? "#4AF075" : "#FF3864"
    } : {};
    const currentValueDiffStyle = clubData?.currentValueDiff !== 0 ? {
        background: clubData?.currentValueDiff > 0 ? "#4AF075" : "#FF3864",
        border: 'none',
        borderRadius : '0px'
    } : {};
    const valueDiffBorder = clubData?.currentValueDiff !== 0
  ? {
      border: clubData.currentValueDiff > 0
        ? "1px solid #4AF075"
        : "1px solid #FF3864"
    }
  : {};

    const [isHover, setIsHover] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isformationLoading , setIsFormationLaoding]= useState<boolean>(false);
    const [isFullViewOpen, setIsFullViewOpen] = useState<boolean>(false);
    const [positionresults , setPositionResults] = useState<ChemistryPlayerPositions[]>([]);
    const [teamChemistry , setTeamChemistry] = useState<TeamChemistry[]>([])
    const [avgAge, setAvgAge] = useState<number>(0);
    const [overallSFScore, setOverallSFScore] = useState<number>(0);
    const [attackContribution, setAttackContribution] = useState<number>(0);
    const [ppda, setPPDA] = useState<number>(0);
      const [formationData, setFormationData] = useState<FormationData[]>([]);
  const [selectedFormation, setSelectedFormation] = useState<number>(0);
    

    // Filter out scores that are 0
    const validScores = teamChemistry.filter(entry => entry.score > 0);
    // Calculate total score and count
    const totalScore = validScores.reduce((sum, entry) => sum + entry.score, 0);
    const avgScore = validScores.length > 0 ? Math.round(totalScore / validScores.length) : 0;

    useEffect(()=>{
        if (isOpen && positionresults && positionresults.length === 0) {
            const fetchSystemFitData = async () =>{
                setIsLoading(true);
                try {
                const response: IApiResponse<ChemistryData> = await postData(`${apiUrls["TeamChemistryNetwork"]}`, {
                    seasonId: 0,
                    teamId: clubData?.teamId,
                    formationId: 0,
                    isOverAll: true,
                    matchIds: []
                });
                handleApiResponse(
                    response,
                    (chemistryData) => {
                    //   setIsChemistryDataNotEnough(false);
                    setPositionResults(chemistryData?.positionResults);
                    const adjustedChemistry = chemistryData?.teamChemstriys.map(connection => ({
                        ...connection,
                        score: connection.score === 100 ? 99 : connection.score
                    }));
                    setTeamChemistry(adjustedChemistry);
                    //   setLastTeamChemistry([]);
                    //   setLastPositionResults([]);
                    //   setIsDisplayInitialRect(false);
                    },
                    (error) => {
                    console.error("Error fetching Chemistry Data:", error);
                    if (error?.message === "No data for current season threshold not reached") {
                        // setIsChemistryDataNotEnough(true);
                    }
                    }
                );
                setIsLoading(false)
                } catch (error) {
                console.error("Error fetching Chemistry Data:", error);
                } 
                setIsLoading(false)
            }
            fetchSystemFitData()
            const fetchAndSetFormation = async () => {
                setIsFormationLaoding(true);
                try {
                    const response: IApiResponse<FormationData[]> = await postData(`${apiUrls["TeamFormations"]}`, {
                      teamId: clubData?.teamId!,
                      matchId: [],
                      //isByMatch: isByMatch,
                      seasonId: 0,
                    });
                    let selectedFormationId: number | null = null;
                    handleApiResponse(
                      response,
                      (formationData) => {
                        if (formationData.length > 0) {
                          selectedFormationId = formationData[0].id;
                          setSelectedFormation(formationData[0].id);
                          setFormationData(formationData.slice(0,2));
                        } else {
                          setFormationData([]);
                        }
                      },
                      (error) => {
                        console.error("Error fetching Formation Data:", error);
                      }
                    );
                    setIsFormationLaoding(false)
                    return selectedFormationId === null ? 0 : selectedFormationId;
                  } catch (error) {
                    console.error("Error fetching Home Team Data:", error);
                    setIsFormationLaoding(false)
                    return null;
                  } 
              

        }
        fetchAndSetFormation();
    }
              // Call the function
    },[isOpen])
    
    useEffect(()=>{
        setAvgAge(Math.trunc(positionresults?.reduce((acc, curr) => acc + curr.age, 0) / 11));
        setAttackContribution(Math.trunc(positionresults?.reduce((acc, curr) => acc + curr.contributionValue, 0) / 10));
        setPPDA(Number(positionresults?.reduce((acc, curr) => acc + curr.ppda, 0).toFixed(2)));
    },[positionresults])

    useEffect(() => {
        setOverallSFScore(avgScore);
    }, [teamChemistry]);

    useEffect(()=>{
        setIsToggleAddSimilarButton(clubData?.isTeamInShortlist!)
    },[clubData])

    const handleAddClub = () => {
        setIsToggleAddSimilarButton(!toggleAddSimilarButton);
        if (toggleAddSimilarButton) {
            setAddedClubShortList(false);
            addUpdateClubSortListData(
                userData,
                [clubData.teamId!],
                startLoading,
                stopLoading,
                setDisplayCustomNotification,
                setCustomNotificationContent,
                true,
                navigate
            );
        } else {
            setAddedClubShortList(true);
            addUpdateClubSortListData(
                userData,
                [clubData.teamId!],
                startLoading,
                stopLoading,
                setDisplayCustomNotification,
                setCustomNotificationContent,
                false,
                navigate
            );
        }
    };

    const handleActions = () => {
        setIsToggleAddSimilarButton(!toggleAddSimilarButton);
        if (!addedClubShortList) {
          addUpdateClubSortListData(
            userData,
            [clubData.teamId!],
            startLoading,
            stopLoading,
            setDisplayCustomNotification,
            setCustomNotificationContent,
            false,
            navigate
          );
        }
      };

    useEffect(() => {
        setCustomNotificationContent(
          <div className="notification">
            <p className="sortlist-notofication-content">
              <BookmarkBorderOutlinedIcon className="icon" />
              <LabelText className="squad-chart-tooltip notification-content">
                {addedClubShortList ? "Club added to your shortlist " : "Club removed from your shortlist"}
              </LabelText>
              {!addedClubShortList ? (
                    <LabelText className="player-given-name notification-content" style={{ cursor: "pointer" }} onClick={() => handleActions()}>
                      Undo
                    </LabelText>
                  ) : (
                    <LabelText
                      className="player-given-name notification-content"
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate("/shortlists")}
                    >
                      View shortlist
                    </LabelText>
                  )}
            </p>
          </div>
        );
      }, [addedClubShortList]);



    

    const getBackgroundColor  = (usagePercentage?: number) => {
        if (usagePercentage! >= 0 && usagePercentage! <= 19) return "#FF3864";
        if (usagePercentage! >= 20 && usagePercentage! <= 39) return "#FF7800";
        if (usagePercentage! >= 40 && usagePercentage! <= 59) return "#F2E94E";
        if (usagePercentage! >= 60 && usagePercentage! <= 100) return "#4AF075";
        return "#F2F5EE"; // Default color if usagePercentage is out of range
    };
    
    const { formattedPosition, formattedDifference, differenceColor, tooltipText } = getLeaguePositionDetails(clubData!);
    
    
    return (
        <>
            <PlayerCardData>
                <div className="player-image-content">
                    <div
                        className="club-badge"
                        onClick={() => {
                            navigate(`/club/${clubData.teamId}`);
                        }}
                    >
                        <img src={clubData?.teamLogoURL ? clubData.teamLogoURL : noImageClub} alt="club-image" />
                    </div>
                    <div
                        className="player-club-detail"
                        onClick={() => {
                            navigate(`/club/${clubData.teamId}`);
                        }}
                    >
                        <div className="clubName-position-container">
                                <LabelText className='player-detail-given-name' style={{ color: theme.NumberColor }}>{clubData?.competitionName} </LabelText>
                                {(clubData?.currentLeaguePosition !== 0 && clubData?.currentLeaguePosition !== null) &&  (
                                    <LabelText className='player-detail-given-name' style={{ color: theme.NumberColor }}>{"  • Currently " + formattedPosition} </LabelText>
                                )}
                                {(clubData?.currentLeaguePosition === 0 || clubData?.currentLeaguePosition === null) && clubData?.currentExpectedLeaguePosition && (
                                    <LabelText className='player-detail-given-name' style={{ color: theme.NumberColor }}>{"  • Expected league pos. " + clubData?.currentExpectedLeaguePosition} </LabelText>
                                )}
                                {(clubData?.currentExpectedLeaguePosition === 0 || clubData?.currentExpectedLeaguePosition === null) &&
                                (clubData?.currentLeaguePosition === 0 || clubData?.currentLeaguePosition === null) ? (
                                    <CustomizedTooltips title="Actual and Expected league pos. data not available for this league">
                                        <img src={InfoIcon} width={24} height={24} style={{ marginTop: '4px' }} />
                                    </CustomizedTooltips>
                                ) : (clubData?.currentExpectedLeaguePosition === 0 || clubData?.currentExpectedLeaguePosition === null) ? (
                                    <CustomizedTooltips title="Expected league pos. data not available for this league">
                                        <img src={InfoIcon} width={24} height={24} style={{ marginTop: '4px' }} />
                                    </CustomizedTooltips>
                                ) : (clubData?.currentLeaguePosition === 0 || clubData?.currentLeaguePosition === null) ? (
                                    <CustomizedTooltips title="Actual league pos. data not available for this league">
                                        <img src={InfoIcon} width={24} height={24} style={{ marginTop: '4px' }} />
                                    </CustomizedTooltips>
                                ) : null}
                                {(clubData?.currentLeaguePosition && clubData?.currentExpectedLeaguePosition) &&(
                                    <CustomizedTooltips title={tooltipText}>
                                        <div className="expected-league-container" style={{ width: '48px',height: '34px'}}>
                                            <LabelNumber style={{ color: differenceColor }}>{formattedDifference}</LabelNumber></div>
                                    </CustomizedTooltips>
                                )}
                        </div>
                        {/* <LabelText className="club-league">{clubData?.competitionName + "  • Currently " + formattedPosition}</LabelText> */}
                        <LabelText className="player-detail-family-name">{clubData?.teamName}</LabelText>
                       
                       
                    </div>
                    
                    <div className="actions-btn">
                    
                        <SecondaryButton
                            label={isOpen && (toggleAddSimilarButton ? "Added to shortlist" : "Add to shortlist")}
                            iconType="bookmark"
                            onClick={() => handleAddClub()}
                            isSelected={toggleAddSimilarButton || addedClubShortList}
                        />
                        <StyledIcon>
                            {isOpen ? (
                                <KeyboardArrowUpIcon sx={{ fontSize: "24px" }} onClick={onToggle} />
                            ) : (
                                <KeyboardArrowDownIcon sx={{ fontSize: "24px" }} onClick={onToggle} />
                            )}
                        </StyledIcon>
                        {/* <div className="club-manager-container"> */}
                                                              
                                                            {/* </div> */}
                                                            
                    </div>
                </div>
               <div style={{display:'flex',flexDirection:'column',width:'fit-content'}}>
               <div style={{alignSelf:'end',marginTop:'-30px'}}>
                <LabelNumber className="stat-row-value">Manager:</LabelNumber>
                <LabelText className="player-given-name">{clubData?.manager}</LabelText>
                </div>
                <div className="player-large-data-details">
                    <PlayerClubCountryInfoData>
                        <PlayerClubInfoData country="country" className="player-descriptive-data" >
                            <LabelNumber className="descriptive-large-text">Country</LabelNumber>
                            <LabelNumber className="descriptive-large-value">{clubData?.countryName || ""}</LabelNumber>
                        </PlayerClubInfoData>
                        <img
                            src={clubData.countryCode ? `/assets/country_flags/${clubData?.countryCode}.svg` : noImageFlag}
                            alt="Club"
                            className="country-image"
                        />
                    </PlayerClubCountryInfoData>
                    <PlayerClubInfoData className="player-descriptive-data">
                        <LabelNumber className="descriptive-large-text">Revenue per season</LabelNumber>
                        <LabelNumber className="descriptive-large-value">
                            {clubData?.totalRevenues ? (
                                `€${formatNumberToKAndMwithoutsign(clubData?.totalRevenues)}`
                            ) : (
                                <EmptyDataButton label="Data not provided by club" />
                            )}
                        </LabelNumber>
                    </PlayerClubInfoData>
                    <PlayerClubInfoData className="player-descriptive-data" >
                        <LabelNumber className="descriptive-large-text">Costs per season</LabelNumber>
                        <LabelNumber className="descriptive-large-value">
                            {clubData?.totalCosts ? (
                                `€${formatNumberToKAndMwithoutsign(clubData?.totalCosts)}`
                            ) : (
                                <EmptyDataButton label="Data not provided by club" />
                            )}
                        </LabelNumber>
                    </PlayerClubInfoData>
                    <PlayerClubInfoData className="player-descriptive-data" style={profitLossStyled}>
                        <LabelNumber className="descriptive-large-text">Profit/loss</LabelNumber>
                        <LabelNumber className="descriptive-large-value">
                            {clubData?.totalProfitLoss ? (
                                `${clubData?.totalProfitLoss >= 0 ? '+' : '-'}€${formatNumberToKAndMwithoutsign(clubData?.totalProfitLoss)}`
                            ) : (
                                <EmptyDataButton label="Data not provided by club" />
                            )}</LabelNumber>
                    </PlayerClubInfoData>
                    <div style={{ display: "flex", borderRadius: "4px", ...valueDiffBorder }}>
                    <PlayerClubInfoData className="player-descriptive-data" style={{border:'none'}}>
                        <LabelNumber className="descriptive-large-text">Squad purchase cost</LabelNumber>
                        <LabelNumber className="descriptive-large-value">{clubData?.squadPurchaseCost ? (
                                `€${formatNumberToKAndMwithoutsign(clubData?.squadPurchaseCost)}`
                            ) : (
                                <EmptyDataButton label="Data not provided by club" />
                            )}</LabelNumber>
                    </PlayerClubInfoData>
                    <PlayerClubInfoData className="player-descriptive-data" style={currentValueDiffStyle}>
                        <LabelNumber className="descriptive-large-text">vs current value</LabelNumber>
                        <LabelNumber className="descriptive-large-value">{clubData?.currentValueDiff ? (
                                `${clubData?.currentValueDiff >= 0 ? '+' : '-'}€${formatNumberToKAndMwithoutsign(clubData?.currentValueDiff)}`
                            ) : (
                                <EmptyDataButton label="Data not provided by club" />
                            )}</LabelNumber>
                    </PlayerClubInfoData>
                    </div>
                </div>
                </div>
               
                {isOpen && (
                    <>
                        <div className="stat-table-container-search-results">
                            <div className="stat-table-column">
                                <TableRow className="stat-table-row">
                                    <LabelText className="selected-zone-name">Manager</LabelText>
                                    <LabelNumber className="club-info-value">
                                    {clubData?.manager}
                                    </LabelNumber>
                                </TableRow>
                                <TableRow className="stat-table-row">
                                    <LabelText className="selected-zone-name">Highest wage pw</LabelText>
                                    <LabelNumber className="club-info-value">
                                        {clubData?.highestWagePerWeek ? (
                                            `€${formatNumberToKAndMwithoutsign(clubData?.highestWagePerWeek)}`
                                        ) : (
                                            <EmptyDataButton label="Data not provided by club" />
                                        )}
                                    </LabelNumber>
                                </TableRow>
                                <TableRow className="stat-table-row">
                                    <LabelText className="selected-zone-name">Av. Wage pW</LabelText>
                                    <LabelNumber className="club-info-value">
                                        {clubData?.averageWagePerWeek ? (
                                            `€${formatNumberToKAndMwithoutsign(clubData?.averageWagePerWeek)}`
                                        ) : (
                                            <EmptyDataButton label="Data not provided by club" />
                                        )}
                                    </LabelNumber>
                                </TableRow>
                                <TableRow className="stat-table-row">
                                    <LabelText className="selected-zone-name">Av. player Age</LabelText>
                                    <LabelNumber className="club-info-value">
                                        {clubData?.avPlayerAge}
                                    </LabelNumber>
                                </TableRow>
                                <TableRow className="stat-table-row">
                                    <LabelText className="selected-zone-name squad-value">Regular squad starters value vs league av.</LabelText>
                                    <LabelNumber className="club-info-value">
                                        {"-"}
                                    </LabelNumber>
                                </TableRow>
                                <TableRow className="stat-table-row">
                                    <LabelText className="selected-zone-name">Bookings this season</LabelText>
                                    <LabelNumber className="chart-content-number fouls-committed">
                                        {/* <strong>.</strong> */}
                                        {clubData?.yellowCards !== null && (
                                            <>
                                                <img src={YellowCardSvg} alt="YellowCardSvg" />
                                                <span className="stat-card-figure">{clubData?.yellowCards}</span>
                                                &nbsp;&nbsp;
                                            </>
                                        )}
                                        {clubData?.redCards !== null && (
                                            <>
                                                <img src={RedCardSvg} alt="RedCardSvg" />
                                                <span className="stat-card-discipline">{clubData?.redCards}</span>
                                            </>
                                        )}
                                    </LabelNumber>
                                    {/* <LabelNumber className="club-info-value">
                                        {"-"}
                                    </LabelNumber> */}
                                </TableRow>
                                <TableRow className="stat-table-row">
                                    <LabelText className="selected-zone-name">Transfer window efficiency</LabelText>
                                    <LabelNumber className="club-info-value">
                                        {"-"}
                                    </LabelNumber>
                                </TableRow>
                                <StyledTags>
                                    <div className="player-tags-wrapper" style={{ display: "flex", flexDirection: "row", position: "relative", justifyContent: "space-between" }}>
                                        <div className="system-fit-header">
                                            {/* <div className="club-formation-container"></div> */}
                                            <ModuleChemHeader className="module-chem-header" style={{marginBottom:'16px'}}>{"Favoured formations"}</ModuleChemHeader>
                                            {/* <div style={{display:'flex',gap:'8px'}}> */}
                                            {formationData.map((formation) => (
                                                <div className="club-formation-content" key={formation.id} style={{ backgroundColor: getBackgroundColor() }}>
                                                    <LabelNumber className="goal-assist-name">{formation.formation}</LabelNumber>
                                                    <LabelNumber className="goal-assist-name">
                                                        {"•  played : " + (formation.usagePercentage > 0 ? formation.usagePercentage : "") + (formation.usagePercentage > 0 ? "%" : '')}
                                                    </LabelNumber>

                                                </div>
                                            ))}
                                            {/* </div> */}
                                            {isformationLoading && <ModuleSpinner/>}
                                        </div>
                                    </div>
                                </StyledTags>
                            </div>
                            <div className="stat-table-column">
                                <TableRow className="stat-table-row">
                                    <LabelText className="selected-zone-name club-earnings-text">DEBT</LabelText>
                                    <LabelNumber className="club-info-value">
                                        {clubData?.totalDebt ? (
                                            `€${formatNumberToKAndM(clubData?.totalDebt)}`

                                        ) : (
                                            <EmptyDataButton label="Data not provided by club" />
                                        )}
                                    </LabelNumber>
                                </TableRow>
                                <TableRow className="stat-table-row">
                                    <LabelText className="selected-zone-name">Assets</LabelText>
                                    <LabelNumber className="club-info-value">
                                        {clubData?.totalAssets ? (
                                            `€${formatNumberToKAndM(clubData?.totalAssets)}`
                                        ) : (
                                            <EmptyDataButton label="Data not provided by club" />
                                        )}
                                    </LabelNumber>
                                </TableRow>
                                <TableRow className="stat-table-row">
                                    <LabelText className="selected-zone-name">Intangible assets</LabelText>
                                    <LabelNumber className="club-info-value">
                                        {clubData?.intangibleAssets ? (
                                            `€${formatNumberToKAndM(clubData?.intangibleAssets)}`
                                        ) : (
                                            <EmptyDataButton label="Data not provided by club" />
                                        )}
                                    </LabelNumber>
                                </TableRow>
                                <TableRow className="stat-table-row">
                                    <LabelText className="selected-zone-name">Liabilities</LabelText>
                                    <LabelNumber className="club-info-value">
                                        {clubData?.totalLiabilities ? (
                                            `€${formatNumberToKAndM(clubData?.totalLiabilities)}`
                                        ) : (
                                            <EmptyDataButton label="Data not provided by club" />
                                        )}
                                    </LabelNumber>
                                </TableRow>
                                <TableRow className="stat-table-row">
                                    <LabelText className="selected-zone-name">Debt vs Asset ratio</LabelText>
                                    <LabelNumber className="club-info-value">
                                        {clubData?.debtVsAssetsRatio ? (
                                            `${clubData?.debtVsAssetsRatio.toFixed(2)}`
                                        ) : (
                                            <EmptyDataButton label="Data not provided by club" />
                                        )}
                                    </LabelNumber>
                                </TableRow>
                                <TableRow className="stat-table-row">
                                    <LabelText className="selected-zone-name">Equity</LabelText>
                                    <LabelNumber className="club-info-value">
                                        {clubData?.totalEquity ? (
                                            `€${formatNumberToKAndM(clubData?.totalEquity)}`
                                        ) : (
                                            <EmptyDataButton label="Data not provided by club" />
                                        )}
                                    </LabelNumber>
                                </TableRow>
                                <TableRow className="stat-table-row">
                                    <LabelText className="selected-zone-name">Receivables Total / due within 12m</LabelText>
                                    <LabelNumber className="club-info-value">
                                        {clubData?.totalReceivables == null || clubData?.totalReceivables == 0 || clubData?.onlyYearReceivables == 0 || clubData?.onlyYearReceivables == null ? (
                                            <EmptyDataButton label="Data not provided by club" />
                                        ) : (
                                            `€${formatNumberToKAndM(clubData?.totalReceivables)}/€${formatNumberToKAndM(clubData?.onlyYearReceivables)}`
                                        )}
                                    </LabelNumber>
                                </TableRow>
                                <StyledTags>
                    <div
                        className="player-tags-wrapper"
                        style={{ display: "flex", flexDirection: "row", position: "relative", justifyContent: "space-between" }}
                    >
                        <div className="system-fit-header">
                        <ModuleChemHeader className="module-chem-header">{"System fit breakdown"}</ModuleChemHeader>
                        {
                            <PartnershipScoreContainer>
                            <p>{"AVERAGE"}</p>
                            <div className="partnership-score">
                                <p>{"PARTNERSHIP SCORE"}</p>
                                <span style={{ marginLeft: "15px" }}>{avgScore ? avgScore : '--'}
                                {/* {currentPlayerView === newPlayer?.playerId! ? newSystemFit : oldSystemFit}{" "} */}
                                {/* {currentPlayerView === newPlayer?.playerId! && (
                                    <span style={{ color: newSystemFit - oldSystemFit > 0 ? "#00D1A8" : "#FF3864" }}>
                                    {newSystemFit - oldSystemFit > 0 && "+"}
                                    {newSystemFit - oldSystemFit}
                                    </span>
                                )} */}
                                </span>
                            </div>
                            </PartnershipScoreContainer>
                        }
                        </div>
                        <div className="small-module-pitch" onMouseOver={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
                        <Pitch
                            currentView={"moduleChemistry"}
                            selectedTeam={clubData?.teamId}
                            positionResults={positionresults}
                            teamChemistry={teamChemistry}
                            // modulefitPlayer={currentPlayerView === oldPlayer?.playerId && club ? oldPlayer?.playerId : newPlayer?.playerId}
                        />
                        {isLoading && <ModuleSpinner />}
                        {isHover && (
                            <FullViewBtn onClick={() => setIsFullViewOpen(true)}>
                            <img src={VisibleON} alt="full-view-button" />
                            </FullViewBtn>
                        )}
                        </div>
                    </div>
                    </StyledTags>

                        </div>
                            </div>
                            <FullModuleFitView
                                        header={"System fit breakdown"}
                                        theme={theme}
                                        isFullViewOpen={isFullViewOpen}
                                        setIsFullViewOpen={setIsFullViewOpen}
                                >
                                    <BothPlayerImageContainer>
                    {/* {club && (
                    <div className="image-container">
                        <div className="module-chemistry-player-image">
                        <PlayerImageContainer isSelected={currentPlayerView === newPlayer?.playerId}>
                            <img src={newPlayer?.playerImageURL!} alt="" onClick={() => setCurrentPlayerView(newPlayer?.playerId!)} />
                        </PlayerImageContainer>
                        <img src={playerData?.clubImageURL} alt="" className="module-chemistry-club-image" />
                        </div>
                        <div className="module-chemistry-player-image">
                        <PlayerImageContainer isSelected={currentPlayerView === oldPlayer?.playerId}>
                            <img src={oldPlayer?.playerImageURL} alt="" onClick={() => setCurrentPlayerView(oldPlayer?.playerId!)} />
                        </PlayerImageContainer>
                        <img src={replacingPlayerClubImg} alt="" className="module-chemistry-club-image" />
                        </div>
                    </div>
                    )} */}
                    <ModuleFitLargePitch
                    positionResults={positionresults}
                    teamChemistry={teamChemistry}
                    />
                    <div className="large-pitch-height"></div>
                <SummaryBar
                style={{ marginLeft: "-40px",bottom : 0}}
                isSwapActive={false}
                selectedTeam={clubData?.teamId!}
                avgAge={avgAge}
                overallSFScore={overallSFScore}
                attackContribution={attackContribution}
                ppda={ppda}
                loading={loading}
            />
                </BothPlayerImageContainer>
                                </FullModuleFitView>
                        {/* </div> */}
                        

                        {/* {type === "candidate" && <ModulePitch clubData={clubData} playerData={playerData} />} */}
                    </>
                )}
            </PlayerCardData>
            {displayCustomNotification && (
                    <PWNotification
                      message={customNotificationContent}
                      setIsNotification={() => setDisplayCustomNotification(false)}
                      isDisplayCloseIcon={true}
                      className="player-filter-notification add-similar-notification"
                    />
                  )}
        </>
    )
}

export default ClubDetails;
